import {
  APPLICATION_BANK_STATUS_KKB,
  BANK_NAME,
} from "../../../../utils/guards/ApplicationBankStatusGuard/types";

export const kkb_paid = {
  bank_name: BANK_NAME.KKB,
  type: APPLICATION_BANK_STATUS_KKB.PAID,
};
export const kkb_offer = {
  bank_name: BANK_NAME.KKB,
  type: APPLICATION_BANK_STATUS_KKB.OFFER,
};
export const kkb_processing = {
  bank_name: BANK_NAME.KKB,
  type: APPLICATION_BANK_STATUS_KKB.PROCESSING,
};
export const kkb_revision = {
  bank_name: BANK_NAME.KKB,
  type: APPLICATION_BANK_STATUS_KKB.REVISION,
};
export const kkb_document_signed = {
  bank_name: BANK_NAME.KKB,
  type: APPLICATION_BANK_STATUS_KKB.DOCUMENT_SIGNED,
};

export const kkb_refusal = {
  bank_name: BANK_NAME.KKB,
  type: APPLICATION_BANK_STATUS_KKB.REFUSAL,
};
